import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {modelFetched} from 'models/ManagedModelsReduxActions';
import * as DataTableDAO from 'notebook/data-tables/DataTableDAO';
import {dataTablesValidationStatusFetchCompleted} from 'notebook/data-tables/DataTableReduxActions';
import {EntryNote} from 'notebook/util/NoteUtilConstants';
import notifications from 'notifications';
import {getStore} from 'redux-stores/Store';
import {getNumDataTables} from 'results/ResultsEntryUtil';

export function fetchDataTablesValidationStatus(entryId: string, note: EntryNote): void {
  if (getNumDataTables(note) === 0) {
    return;
  }
  DataTableDAO.fetchDataTablesValidationStatus(entryId).then(
    ({assayResultsById, assayResultValidationsByResultId, errorsByRecordId}) => {
      getStore().dispatch(dataTablesValidationStatusFetchCompleted(errorsByRecordId, assayResultsById));
      getStore().dispatch(
        modelFetched(ManagedModelType.ASSAY_RESULT_VALIDATION, assayResultValidationsByResultId)
      );
    },
    (response) => {
      notifications.notifyError(response);
    }
  );
}
